import img1 from "../assets/gallery1.jpg";
import img2 from "../assets/gallery2.jpg";
import img3 from "../assets/gallery3.jpg";
import img4 from "../assets/gallery4.jpg";
import img5 from "../assets/gallery5.jpg";
import img6 from "../assets/gallery6.jpg";
function CampusGallery() {
  return (
    <div className="gallery">

      <h2>Campus Gallery</h2>

      <p className="gallery-text">
        A glimpse into the vibrant life, modern infrastructure, and academic 
        environment at Tejkirti Senior Women’s College.
      </p>

      <div className="gallery-grid">

        <div className="gallery-item">
          <img src={img1} alt="campus" />
        </div>

        <div className="gallery-item">
          <img src={img2} alt="campus" />
        </div>

        <div className="gallery-item">
          <img src={img3} alt="campus" />
        </div>

        <div className="gallery-item">
          <img src={img4} alt="campus" />
        </div>

        <div className="gallery-item">
        <img src={img5} alt="campus" />
        </div>

        <div className="gallery-item">
        <img src={img6} alt="campus" />
       </div>

      </div>

    </div>
  );
}

export default CampusGallery;